import { useEffect, useId } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '@/core/interfaces/store';
import { useAppDispatch } from '@/core/store/store';
import {
  getModalZIndexSelector,
  pushModal,
  removeModal,
} from '@/core/store/reducers/modalStackSlice';
import { OVERLAY_STACK_TOP_Z_INDEX } from '@/core/constants/zIndex';

export const useTopmostZIndex = (
  isOpen: boolean,
  baseZIndex: number = OVERLAY_STACK_TOP_Z_INDEX
): number => {
  const id = useId();
  const dispatch = useAppDispatch();
  const zIndex = useSelector((state: RootState) => getModalZIndexSelector(state, id, baseZIndex));

  useEffect(() => {
    if (!isOpen) return undefined;

    dispatch(pushModal(id));

    return () => {
      dispatch(removeModal(id));
    };
  }, [dispatch, id, isOpen]);

  return zIndex;
};
